import React from "react";

const ErrorBoundary = () => {
	return <div>This Page has an errror that must be resolved</div>;
};

export default ErrorBoundary;
